import { Message } from 'app/domains/common-ui/Chat';
import { getPromptByType } from '../getPromptByType';
export function UserMessage(props) {
    const { message, type } = props;
    const prompt = getPromptByType(type);
    // Show prompt if available, otherwise show message
    const markdown = prompt || message.markdown;
    return <Message align="right" appearance="primary" message={Object.assign(Object.assign({}, message), { markdown })}/>;
}
